import { useEffect } from 'react';
import type { Project } from '../domain/schemas';
import type { AudioEngine } from './audioEngine';

/** Keeps the (lazily started) audio engine in sync with the open project. */
export function useAudioSync(engine: AudioEngine, project: Project): void {
  useEffect(() => engine.setProject(project), [engine, project]);
  // Stop playback when the project is closed (context is suspended, not leaked).
  useEffect(() => () => void engine.stop(), [engine]);
}
